module.exports = __webpack_public_path__ + "img/marketing-budget.04b4606c.svg";